import React from 'react'
import './styles.css'

const CreateTodo = () => {
  return (
    <div>
      {' '}
      <div className="createTodo">
        <figure>
          <img
            src="https://i.postimg.cc/mk45YCK4/pngwing-com-22-1.png"
            alt="Create your first Todo"
          />
          <figcaption>Create a Todo</figcaption>
        </figure>
      </div>
    </div>
  )
}

export default CreateTodo
